// @ts-nocheck
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@mui/material';
import { ReactComponent as FormatBoldIcon } from '../../../../../assets/Icons/lucideIcons/bold.svg';
import { ReactComponent as FormatItalicIcon } from '../../../../../assets/Icons/lucideIcons/italic.svg';
import { ReactComponent as FormatUnderlinedIcon } from '../../../../../assets/Icons/lucideIcons/underline.svg';

import ColorGroup from './ColorGroup';
import GroupWrapper from '../Wrappers/GroupWrapper';

const FontStyleGroup = ({ cellFormat, onFormatChange }) => {
  const handleBoldClick = useCallback(() => {
    onFormatChange('bold');
  }, [onFormatChange]);

  const handleItalicClick = useCallback(() => {
    onFormatChange('italic');
  }, [onFormatChange]);

  const handleUnderlineClick = useCallback(() => {
    onFormatChange('underline');
  }, [onFormatChange]);

  return (
    <GroupWrapper label="Font">
      <Tooltip title="Bold">
        <IconButton
          size="small"
          onClick={handleBoldClick}
          color={cellFormat?.fontWeight ? 'primary' : 'default'}
        >
          <FormatBoldIcon width={18} height={18} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Italic">
        <IconButton
          size="small"
          onClick={handleItalicClick}
          color={cellFormat?.fontStyle ? 'primary' : 'default'}
        >
          <FormatItalicIcon width={18} height={18} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Underline">
        <IconButton
          size="small"
          onClick={handleUnderlineClick}
          color={cellFormat?.textDecoration ? 'primary' : 'default'}
        >
          <FormatUnderlinedIcon width={18} height={18} />
        </IconButton>
      </Tooltip>
      <ColorGroup cellFormat={cellFormat} onFormatChange={onFormatChange} />
    </GroupWrapper>
  );
};

FontStyleGroup.propTypes = {
  cellFormat: PropTypes.shape({
    fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
      .isRequired,
    fontStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
      .isRequired,
    textDecoration: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
      .isRequired,
  }).isRequired,
  onFormatChange: PropTypes.func.isRequired,
};

export default FontStyleGroup;
